import { ReportReason, ResourceType } from '@foxbun/lib-goferal-types';
import { ImageModel, ImageModelData } from './ImageModel';
import type { ProfileModel } from './ProfileModel';
import { generatePath } from 'react-router-dom';
import { Routing } from '../../pages/Routing';

export class ProfileImageModel extends ImageModel {
  constructor(
    data: ImageModelData,
    protected profile: ProfileModel
  ) {
    super(data);
  }

  canEdit() {
    return this.profile.isMe;
  }

  get editLink(): string | null {
    if (!this.canEdit()) {
      return null;
    }
    return generatePath(Routing.EDIT_IMAGE, {
      id: this._id.toString()
    });
  }

  async delete() {
    if (!this.canEdit()) {
      throw new Error('Image is not deletable');
    }
    await this.profile.deleteGalleryImage(this._id);
  }

  async report() {
    if (this.canEdit()) {
      throw new Error('Image is not reportable');
    }
    await this.profile.api_client.moderation.report({
      target_type: ResourceType.IMAGE,
      target_id: this._id,
      reason: ReportReason.INAPPROPRIATE_CONTENT
    });
  }
}
